import React from 'react';
import { compose, withPropsOnChange } from 'recompose';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from '../../styles/widgets/adverts/adverts-widget.module.scss';
import { THeadline } from '../../components/template';
import { AdvertLink } from '../../components/advert';
import { withWidgetController } from '../../pages/dashboard/components/with-controller';
import { withGridContext } from '../../pages/dashboard/components/with-grid';
import { withWidgetTracking } from '../../pages/dashboard/hocs/with-widget-tracking';
import { ADVERT_VIEW_MODE_TYPED, getAdvertViewMode } from '../../helpers/advert/advert';
import { AdvertLinkViewController } from './view';

const Component = React.memo(({ adverts, title, subtitle, groupName, mode, configuration }) => {
  return (
    <>
      <THeadline className={styles.headline} title={title} subtitle={subtitle} />
      <AdvertLinkViewController advertName={`advert_${groupName}`} mode={mode} configuration={configuration}>
        {adverts.map(
          ({
            title,
            titleIcon,
            bodyText,
            imageUrl,
            backgroundImageUrl,
            foregroundImageUrl,
            inlineImageUrl,
            link,
            isExternal,
            styling,
            actions
          }) => (
            <AdvertLink
              key={title}
              titleAs='h3'
              title={title}
              titleIcon={titleIcon}
              body={bodyText}
              backgroundImageUrl={backgroundImageUrl}
              foregroundImageUrl={foregroundImageUrl}
              inlineImageUrl={inlineImageUrl}
              imageUrl={imageUrl}
              to={link}
              isExternal={isExternal}
              styling={styling}
              actions={actions}
            />
          )
        )}
      </AdvertLinkViewController>
    </>
  );
});

Component.displayName = 'AdvertLinksComponent';

const Widget = compose(
  withPropsOnChange(['styling'], ({ styling }) => ({
    className: classnames(styles.container, { [styles[styling]]: !!styling })
  })),
  withPropsOnChange(
    ['viewMode', 'gridConfiguration', 'sliderConfiguration'],
    ({ viewMode, gridConfiguration, sliderConfiguration }) => {
      const mode = getAdvertViewMode(viewMode);

      return {
        mode,
        configuration: mode === ADVERT_VIEW_MODE_TYPED.slider ? sliderConfiguration : gridConfiguration
      };
    }
  ),
  withWidgetController(),
  withGridContext,
  withWidgetTracking
)(Component);

Widget.displayName = 'AdvertLinksWidget';

Widget.propTypes = {
  viewMode: PropTypes.oneOf(['grid', 'slider']),
  styling: PropTypes.oneOf(['option-1', 'option-2', 'option-3']),
  gridConfiguration: PropTypes.object,
  sliderConfiguration: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  grid: PropTypes.bool,
  edge: PropTypes.bool
};

export { Widget };
